import axiosInstance from '../../../api/AxiosInstance';
import { endpoints } from '../../../services/endpoints';
import { addProductTypeRequest, addProductTypeRequestError, addProductTypeRequestSuccess } from '../../slices/Content/AddProductTypeSlice';

export const AddProductTypeAPI = (data) => {
    return async (dispatch) => {
        try {
            dispatch(addProductTypeRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.addProductType,
                data: data,
            })
            return dispatch(addProductTypeRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(addProductTypeRequestError(_error));
        }
    };
};
